import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
// ✅ Get current month in YYYY-MM format
const getCurrentMonth = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}`;
};
const parseMonthFromUrl = (search, state) => {
    const params = new URLSearchParams(search);
    const monthParam = params.get('month') || state?.month;
    const yearParam = params.get('year') || state?.year;
    const dateParam = params.get('date') || state?.date;
    if (monthParam) {
        // Format: YYYY-MM or YYYY-M
        if (/^\d{4}-\d{1,2}$/.test(monthParam)) {
            const [y, m] = monthParam.split('-');
            return `${y}-${m.padStart(2, '0')}`;
        }
        // Format: ISO date YYYY-MM-DD
        if (/^\d{4}-\d{1,2}-\d{1,2}/.test(monthParam)) {
            const [y, m] = monthParam.split('-');
            return `${y}-${m.padStart(2, '0')}`;
        }
        // Format: 1-12 or 01-12 with optional year
        if (/^\d{1,2}$/.test(monthParam)) {
            const year = yearParam && /^\d{4}$/.test(yearParam) ? yearParam : new Date().getFullYear();
            return `${year}-${monthParam.padStart(2, '0')}`;
        }
    }
    if (dateParam) {
        if (/^\d{4}-\d{1,2}/.test(dateParam)) {
            const [y, m] = dateParam.split('-');
            return `${y}-${m.padStart(2, '0')}`;
        }
    }
    return null;
};
export const useMonthSelection = () => {
    const location = useLocation();
    const cache = useSelector((state) => state.utility.cache);
    const isCacheLoaded = useRef(false);
    const initialUrlMonth = parseMonthFromUrl(location.search, location.state);
    const [selectedMonth, setSelectedMonth] = useState(initialUrlMonth || getCurrentMonth());
    // ✅ Sync if URL search params or state change
    useEffect(() => {
        const urlMonth = parseMonthFromUrl(location.search, location.state);
        if (urlMonth) {
            setSelectedMonth(urlMonth);
        }
    }, [location.search, location.state]);
    // ✅ Load from cache only if URL did not provide a month
    useEffect(() => {
        if (cache && !isCacheLoaded.current) {
            const urlMonth = parseMonthFromUrl(location.search, location.state);
            if (!urlMonth && cache.month) {
                setSelectedMonth(cache.month);
            }
            isCacheLoaded.current = true;
        }
    }, [cache, location.search, location.state]);
    return {
        selectedMonth,
        setSelectedMonth
    };
};
